module.exports = __webpack_public_path__ + "img/work2022-chi-math.80ae9e0e.gif";